import { InputValidatorGenerator } from "./InputValidator";
import { isValidEmail } from "helpers/validateEmail";

export const isValidEmailAddress: InputValidatorGenerator = () => (value) =>
  !!value && isValidEmail(value) ? undefined : "Invalid email address";
